import firebase from "firebase/compat/app";
import "firebase/compat/functions";
import { mutate } from "swr";
import useSWRImmutable from "swr/immutable";

import type {
  GetUserCartRequest,
  GetUserCartResponse,
  UserCartDTO,
} from "@spwn/types/functions";
import type { KeyedMutator } from "swr";

export type UserCart = GetUserCartResponse;

const functionName = "getUserCart";
const generateKey = () => functionName;

export const useGetUserCart = (): {
  data: UserCart;
  error: unknown;
  isValidating: boolean;
  mutate: KeyedMutator<UserCartDTO>;
} => {
  const { data, error, isValidating, mutate } = useSWRImmutable(
    generateKey(),
    async () => {
      const { data } = await callGetUserCart();
      return data;
    }
  );
  return {
    // @ts-expect-error TS2322
    data,
    error,
    isValidating,
    mutate,
  };
};

const callGetUserCart = async (
  request: GetUserCartRequest
): Promise<{ data: GetUserCartResponse }> => {
  return await firebase.functions().httpsCallable(functionName)(request);
};

/**
 * 再検証
 */
export const revalidate = async (): Promise<void> => {
  await mutate(generateKey());
};
